<div class="logo-search">
	<button class="menu-launcher" (click)="openMenu()" aria-label="Open the menu">
		<svg-icon key="menu" height="24px" width="24px"></svg-icon>
	</button>
	<img class="logo" ngSrc="assets/fit-logo-color.svg" height="36" width="120"
		 alt="FIT Logo"
		 priority/>
	<app-omni-search></app-omni-search>
	<button class="mobile-search-button" [routerLink]="[{ outlets: { actionbar: 'omni-search'}}]">
		<svg-icon key="search"></svg-icon>
	</button>
</div>

<ul class="header-actions">
	@if (!user?.claim?.contactID) {
		<li>
			<a [routerLink]="[]" (click)="login()">
				<svg-icon key="login"></svg-icon>
				Login
			</a>
		</li>
	}
	@if (user?.claim?.contactID) {
		<li>
			<a [routerLink]="[]" (click)="logoutDialog?.showModal()">
				<svg-icon key="logout"></svg-icon>
				Logout
			</a>
		</li>
	}
</ul>
<app-dialog #logoutDialog [showCloseButton]="true" title="Logout Confirmation" class="generic"
			aria-describedby="description">
	<p id="description">Please confirm you wish to logout as an authenticated user. After logout, you will be taken to
		the Explore page.</p>
	<ng-container class="actions">
		<button class="dialog-button large outline" (click)="logoutDialog.close()">
			Cancel
		</button>
		<button class="dialog-button large solid" autofocus=autofocus (click)="logout()">
			<svg-icon key="check"></svg-icon>
			Logout
		</button>
	</ng-container>
</app-dialog>




